import Vue from 'vue'
import ProductItemsService from 'js/services/api/billing/product-items.js'
import ProductDataMixin from 'js/pages/municipality-data/balance/products/_product-data.js'
import {mapGetters} from 'vuex'
import ProductCard from './_product-card'
import template from './index.pug'
import Show from '../show'

const TAB_AVAILABLE = 0

// @vue/component
export default {
  template: template(),

  components: {
    ProductCard,
    Show
  },

  mixins: [ProductDataMixin],

  data() {
    return {
      products: [],
      tab: TAB_AVAILABLE,
      pagination: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      },
      tabs: [
        {
          id: 0,
          label: Vue.i18n.t('balance.products.tabs.available'),
          disabled: false
        },
        {
          id: 1,
          label: Vue.i18n.t('balance.products.tabs.historical'),
          disabled: false
        }
      ],
      visibleCards: true
    }
  },

  created() {
    this.getProducts()
  },

  methods: {
    async getProducts() {
      const params = {
        administrative_area_id: this.administrativeArea.id,
        order_by: 'create_at',
        order_dir: 'desc',
        per: 0
      }

      /**
       * For get product historical, no send status and has_qr_available
       */
      if (this.tab === TAB_AVAILABLE) {
        params.status = 'active'
        params.has_qr_available = 'true'
        params.order_by = 'updated_at'
      }

      const products = (await ProductItemsService.index(params)).data
      this.products = products
      this.visibleCards = true
      const firstPosition = (this.pagination.currentPage - 1) * this.pagination.limit
      this.products = this.products.slice(firstPosition, firstPosition + this.pagination.limit)
      this.pagination.totalElements = products.length
    },

    showProduct(id) {
      this.$router.push({name: 'wallet-products-show', params: {id}})
    },

    changeTab(index) {
      this.tab = this.tab === index ? null : index
      this.visibleCards = false
      this.getProducts()
    },

    isTabActive(tab) {
      return tab.id === this.tab
    },
    changeLimit(limit) {
      this.pagination.limit = limit
      this.pagination.currentPage = 1
      this.getProducts()
    },
    changePage(page) {
      this.pagination.currentPage = page
      this.getProducts()
    }
  }
}
